import {
  Menu as HuiMenu,
  MenuButton,
  MenuItem,
  MenuItems,
  MenuSeparator,
} from "@headlessui/react";
import type { LucideIcon } from "lucide-react";
import { Fragment, type ReactNode } from "react";

import { cn } from "./cn";
import { SHEET_PANEL, SHEET_ROW, useSheet } from "./sheet";

export interface MenuAction {
  key: string;
  label: string;
  icon?: LucideIcon;
  onSelect: () => void;
  disabled?: boolean;
  /** Опасное действие отмечается и цветом, и положением — но цвет не подпись. */
  danger?: boolean;
  /** Разделитель перед пунктом. */
  separated?: boolean;
}

interface MenuProps {
  trigger: ReactNode;
  actions: MenuAction[];
  align?: "start" | "end";
}

export function Menu({ trigger, actions, align = "end" }: MenuProps) {
  // На телефоне — нижний лист (sheet.ts): без привязки к кнопке, в портале.
  const sheet = useSheet();
  return (
    <HuiMenu>
      {/*
        as={Fragment}: триггер САМ становится кнопкой меню и получает
        обработчики, aria-атрибуты и ref. Обёртка <div className="contents">
        здесь не работала — меню не открывалось ни мышью, ни с клавиатуры,
        а кнопка внутри кнопки к тому же ломает разметку для скринридера.
      */}
      <MenuButton as={Fragment}>{trigger}</MenuButton>
      <MenuItems
        {...(sheet
          ? { portal: true, className: SHEET_PANEL }
          : {
              anchor: { to: align === "end" ? "bottom end" : "bottom start", gap: 4 } as const,
              className:
                "z-50 min-w-48 rounded-md border border-line bg-raised p-1 shadow-md focus:outline-none",
            })}
      >
        {actions.map((action) => (
          <div key={action.key}>
            {action.separated && <MenuSeparator className="my-1 h-px bg-line" />}
            <MenuItem disabled={action.disabled === true}>
              <button
                type="button"
                onClick={action.onSelect}
                className={cn(
                  "flex w-full items-center gap-2 rounded-sm text-left",
                  sheet ? SHEET_ROW : "px-2.5 py-1.5 text-[13px]",
                  "data-focus:bg-sunken data-disabled:cursor-not-allowed data-disabled:opacity-40",
                  action.danger ? "text-danger" : "text-fg",
                )}
              >
                {action.icon && <action.icon className="size-4 shrink-0" aria-hidden />}
                {action.label}
              </button>
            </MenuItem>
          </div>
        ))}
      </MenuItems>
    </HuiMenu>
  );
}
